import React, { useEffect, useState } from "react";

/**
 * doc source : https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-link/#reminder-use-link-only-for-internal-links
 * @param children
 * @param to
 * @param activeClassName
 * @param partiallyActive
 * @param other
 * @returns {JSX.Element}
 * @constructor
 */
export const Link = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  ...other
}) => {
  const internal =
    to?.length === 1 || to === "#" || to === "/" || /^\/(?!\/)/.test(to);

  const [allCookies, setAllCookies] = useState({
    first_session: "",
    returning_session: "",
    gclid: ""
  });

  useEffect(() => {
    const returningSession = JSON.parse(
      window?.localStorage.getItem("ReturningSession") || "{}"
    );
    const firstSession = JSON.parse(
      window?.localStorage.getItem("FirstSession") || "{}"
    );

    const getAllAttr = {
      first_session: firstSession,
      returning_session: returningSession,
      gclid: returningSession?.gclid ?? firstSession?.gclid ?? ""
    };

    setAllCookies(getAllAttr);
  }, []);

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <a
        href={to}
        // activeClassName={activeClassName}
        // partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </a>
    );
  } else {
    const firstSession = () => {
      const sessionVal = allCookies.first_session;
      return {
        utm_source: sessionVal?.source ?? "",
        utm_medium: sessionVal?.medium ?? "",
        utm_campaign: sessionVal?.campaign ?? "",
        utm_term: sessionVal?.term ?? "",
        utm_content: sessionVal?.content ?? "",
        adgroup: sessionVal?.utm_adgroup ?? "",
        msclkid: sessionVal?.msclkid ?? "",
        ttclid: sessionVal?.ttclid ?? "",
        fbclid: sessionVal?.fbclid ?? "",
        gbraid: sessionVal?.gbraid ?? "",
        wbraid: sessionVal?.wbraid ?? ""
      };
    };

    const returningSession = () => {
      const sessionVal = allCookies.returning_session;
      return {
        gvi_source: sessionVal?.source ?? "",
        gvi_medium: sessionVal?.medium ?? "",
        gvi_campaign: sessionVal?.campaign ?? "",
        gvi_term: sessionVal?.term ?? "",
        gvi_content: sessionVal?.content ?? "",
        adgroup: sessionVal?.utm_adgroup ?? "",
        msclkid: sessionVal?.msclkid ?? "",
        ttclid: sessionVal?.ttclid ?? "",
        fbclid: sessionVal?.fbclid ?? "",
        gbraid: sessionVal?.gbraid ?? "",
        wbraid: sessionVal?.wbraid ?? ""
      };
    };

    const otherParams = () => {
      const gclid = allCookies.gclid;
      return {
        gclid: gclid ?? ""
      };
    };

    let externalLinkWithParams = "";
    if (/(https:|http:)/.test(to) === false) {
      externalLinkWithParams = to ?? "#";
    } else {
      const urlTarget = new URL(to);
      const params = {
        ...firstSession(),
        ...returningSession(),
        ...otherParams()
      };

      for (const [ckey, cdetail] of Object.entries(params).sort()) {
        if (cdetail) {
          urlTarget.searchParams.set(ckey, cdetail);
        }
      }

      externalLinkWithParams = urlTarget.href;
    }

    return (
      <a href={externalLinkWithParams} {...other}>
        {children}
      </a>
    );
  }
};
